<template>
    <div
        class="fixed left-0 top-0 w-full h-full z-60 bg-hh-grey-900/90 text-hh-grey-50 transition"
        :class="{ 'opacity-100 pointer-events-auto': this.isActive, 'opacity-0 pointer-events-none': ! this.isActive }"
    >
        <swiper
            ref="swiper"
            class="swiper"
            :class="{ 'opacity-0': isLoading, 'opacity-100': ! isLoading }"
            @swiper="onSwiper"
            :slides-per-view="1"
            :space-between="16"
            :scrollbar="{ draggable: true }"
            :grab-cursor="true"
            :loop="true"
            :keyboard="{ enabled: true }"
            :pagination="{
                type: 'fraction',
            }"
        >
            <swiper-slide class="swiper-slide flex items-center justify-center relative p-12 xl-max:px-2 h-full" v-for="(image, index) in swiperSlides">
                <picture :title="image.altText" class="xl:h-full overflow-hidden ">
                    <source :srcset="xxl(image.urlWebp)" type="image/webp">
                    <img
                        width="100%"
                        height="100%"
                        class="mx-auto xl:h-full "
                        :src="image.url"
                        :alt="image.altText"
                        loading="lazy"
                        draggable="false"
                        @contextmenu="handler($event)"
                    />
                </picture>
            </swiper-slide>

            <button class="fixed right-4 top-2 w-8 h-8 text-center cursor-pointer z-60" @click.prevent="close()">

                <img
                    width="40"
                    height="40"
                    class="w-10"
                    src="/assets/img/frontend-v3/icons/global/icon-x-grey-50.svg"
                    alt="x"
                >
            </button>
        </swiper>

        <div
            :class="[navButtonCSS(), '' ]"
            @click="prevSlide()"
        >
            <img
                width="48"
                height="48"
                class="xl:bg-hh-grey-50 xl:bg-transparent rounded-full p-1 w-12 rotate-180"
                src="/assets/img/frontend-v3/icons/global/icon-right-angle-cyan.svg"
                alt="right angle"
            >
        </div>
        <div
            :class="[navButtonCSS(), 'right-0' ]"
            @click="nextSlide()"
        >
            <img
                width="48"
                height="48"
                class="xl:bg-hh-grey-50 xl:bg-transparent rounded-full p-1 w-12"
                src="/assets/img/frontend-v3/icons/global/icon-right-angle-cyan.svg"
                alt="right angle"
            >
        </div>
    </div>
</template>

<script>
// :observer="true"
// :observeParents="true"

import {Swiper, SwiperSlide} from 'swiper/vue';
import SwiperCore, { Keyboard, Scrollbar, Navigation, Pagination } from 'swiper';

SwiperCore.use([Keyboard, Scrollbar, Navigation, Pagination ]);

export default {

    name: 'DetailGallery',

    props: ['swiper-data', 'ip-valid'],

    components: {
        Swiper,
        SwiperSlide,
    },

    data() {
        return {
            swiper: null,
            isLoading: true,
            isActive: false,
            swiperSlides: {},
        }
    },

    created() {
        this.swiperSlides = this.swiperData;
    },

    mounted() {
        this.stopLoading();

        this.Bus.on('open-detail-gallery', (index) => {
            this.open(index);
        });

        this.swiper?.on('swiper', this.onSwiperChange);

        window.addEventListener('keydown', this.handleEscapeKey);
    },

    beforeDestroy() {
        window.removeEventListener('keydown', this.handleEscapeKey);
        this.swiper?.off('swiper', this.onSwiperChange);

    },

    methods: {

        onSwiper(swiper) {
            this.swiper = swiper;
        },

        nextSlide() {
            this.swiper.slideNext();
        },

        prevSlide() {
            this.swiper.slidePrev();
        },

        stopLoading() {
            this.isLoading = false;
        },

        navButtonCSS() {
            return 'inline-block fixed top-1/2 -translate-y-1/2 w-12 cursor-pointer select-none z-60';
        },

        open(slideIndex = 0) {
            this.swiper.slideTo(slideIndex, 0);
            this.isActive = true;
        },

        close() {
            this.isActive = false;
        },

        xxl(url) {
            return url.replace('/xlarge/', '/xxlarge/');
        },

        handler: function (e) {
            if (! this.ipValid) {
                e.preventDefault();
            }
        },

        handleEscapeKey(event) {
            if (event.key === 'Escape') {
                this.close();
            }
        }
    }
};
</script>
